// extracted by mini-css-extract-plugin
module.exports = {"pages":"styles_pages__XuI_a","pagesContent":"styles_pagesContent__l31qe","carouselIndicatorsWrapper":"styles_carouselIndicatorsWrapper__0w2gK"};